// Copyright (c) Jonathan Ferraz.
// Licensed under the MIT license.

import { FadeInSection } from './FadeInSection';

export default FadeInSection;
